var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { class: { open: _vm.menu.isOpen }, attrs: { id: "sidebar" } },
    [
      _c(
        "header",
        {
          on: {
            click: function ($event) {
              return _vm.toggleMenu(false)
            },
          },
        },
        [
          _vm.menu.isOpen ? _c("h1", [_vm._v("SUPSIS")]) : _vm._e(),
          _vm._v(" "),
          _c("Arrows", {
            class: { open: _vm.menu.isOpen },
            attrs: {
              "is-animated": true,
              id: "arrow-icon",
              "data-v-step": "2",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.permissions.length || _vm.isAdmin
        ? _c(
            "ul",
            {
              key: "menu-" + _vm.forceRenderCount,
              ref: "scrollRef",
              staticClass: "list-unstyled",
            },
            _vm._l(_vm.allowedRoutes(), function (item, index) {
              return _c(
                "li",
                { key: index },
                [
                  item.children === undefined || item.children.length === 0
                    ? _c(
                        "router-link",
                        { attrs: { to: item.path } },
                        [
                          _c(
                            "a-tooltip",
                            {
                              attrs: { title: item.title, placement: "right" },
                              on: {
                                click: function ($event) {
                                  return _vm.clickItem(item)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "div",
                                    [
                                      item.antIcon
                                        ? _c("a-icon", {
                                            staticStyle: {
                                              "font-size": "20px",
                                            },
                                            style: {
                                              color: _vm.bugExist
                                                ? "red !important"
                                                : "#9ba2b6 !important",
                                            },
                                            attrs: { type: item.antIcon },
                                          })
                                        : _c(item.icon, {
                                            tag: "component",
                                            staticClass: "myIcon",
                                            style: {
                                              fill:
                                                item.icon === "ticket" &&
                                                _vm.getWaitingTickets.length > 0
                                                  ? "#d5295c !important"
                                                  : "inherit",
                                            },
                                          }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.title))]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a-tooltip",
                    { attrs: { title: item.title, placement: "right" } },
                    [
                      item.children !== undefined && item.children.length
                        ? _c(
                            "a",
                            {
                              staticClass: "pointer-event",
                              on: {
                                click: function ($event) {
                                  return _vm.toggleShowChildren(item.path)
                                },
                              },
                            },
                            [
                              _c(item.icon, {
                                tag: "component",
                                staticClass: "myIcon",
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.title))]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  item.children !== undefined &&
                  item.children.length &&
                  item.showChildren === true
                    ? _c(
                        "ul",
                        { staticClass: "list-unstyled" },
                        _vm._l(item.children, function (item2, index2) {
                          return _c(
                            "li",
                            { key: index2 },
                            [
                              _c(
                                "router-link",
                                { attrs: { to: item2.path } },
                                [
                                  _c(
                                    "a-tooltip",
                                    {
                                      attrs: {
                                        title: item2.title,
                                        placement: "right",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleMenu(true)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c(item2.icon, {
                                            tag: "component",
                                            staticClass: "myIcon",
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(item2.title)),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }